import React, { useEffect, useState } from 'react';
import { subscribeActivity } from '../services/activity';

// A thin red bar along the top of the window while the app waits on the server (services/activity.js). It shows only
// when a wait lasts more than a moment (SHOW_AFTER), so quick requests don't flicker it.
const SHOW_AFTER = 350;

const ActivityBar = () => {
  const [busy, setBusy] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeActivity(n => setBusy(n > 0)), []);
  useEffect(() => {
    if (!busy) { setVisible(false); return undefined; }
    const t = setTimeout(() => setVisible(true), SHOW_AFTER);
    return () => clearTimeout(t);
  }, [busy]);

  if (!visible) return null;
  return <div className="activity-bar no-print" role="progressbar" aria-label="Cargando" />;
};

export default ActivityBar;
